import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problemas" className="border-y border-white/5 bg-ink-2" data-id="element-113" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" data-id="element-114" data-mp="26xei5i7cgx71">
        <h2 className="text-center font-display text-[25px] font-black text-white sm:text-4xl" data-id="element-115" data-mp="2bxiuqx54t7rz">
          ❌ ¿Cuántos errores más vas a cometer reaccionando desde el pánico?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-116" data-mp="1y0427jjl0jvs">
          Descubriste una infidelidad. Querés respuestas. Pero nadie te dijo que las próximas 72
          horas son las más peligrosas de tu vida de pareja, donde cada decisión tomada desde el
          shock puede destruir tu futuro para siempre.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-plata" data-id="element-117" data-mp="3iewalljh6ae9">
          No es debilidad. No es locura. Es que nadie te dio un protocolo.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-118" data-mp="1yzvirhfuantx">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-119" data-mp="1u2disgjsviy2" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-vino/50 text-sm" aria-hidden="true" data-id="element-120" data-mp="1b2ptdvi9b8uh">
                {p.emoji}
              </span>
              <div data-id="element-121" data-mp="1k34ofml0w2b6">
                <h3 className="text-sm font-bold text-white" data-id="element-122" data-mp="1k1uqcxe66u4j">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-123" data-mp="30gux76n37er5">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-124" data-mp="2vkxfox0382cs">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-125" data-mp="1t5yc0u516v78">
            ¿Y si esta fuera la última semana que navegás esta crisis sin un método real?
          </p>
          <p className="mt-3 text-lg font-semibold text-rojo-soft" data-id="element-126" data-mp="225bmnq4w5ptj">
            El próximo paso puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}